import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _RequestAdquisitionItem, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../../theme/Component/BasicButton";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Approve: string;
}

export const SPAA003 = ({ configProcedure }: Props) => {

    const item = useDataBean(_AdquisitionItem);
    const { instance, spin, bean, setBean } = useDataBean(_RequestAdquisitionItem);

    const [props, setProps] = useState<any>({})

    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Obs: ""
    })

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        if (props?.IDRequestAdquisitionItem) {
            instance.getRequestAdquisitionItem(props?.IDRequestAdquisitionItem).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(err => { toast.error("No se pudo obtener la información") })
        }
    }, [props?.IDRequestAdquisitionItem])


    const onExportMap = (responseData) => {

        instance.updateRequestAdquisitionItem({ ...bean, IDEmployeeApprove: _single.getAccountID(), State: response.Approve == "true" ? 101 : 102 }).then(
            (resp) => {

                changeState(responseData)

                if (configProcedure?._pushInfo) {
                    configProcedure?._pushInfo(_single.jsonToBootstrapTable({
                        "Estado de Gestion": response.Approve == "true" ? "Aprobada" : "Rechazada",
                        "Observaciones": response.Obs,
                    }));
                }

                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap({
                        Approve: response.Approve,
                        Obs: response.Obs
                    })
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const handleApprove = (currentResponse: Resp) => {
        if (currentResponse.Obs.length > 15) {
            onExportMap(7);
        } else {
            toast.error("La justificación debe tener mínimo 15 caracteres");
        }
    };

    const handleDecline = (currentResponse: Resp) => {

        if (currentResponse.Obs.length > 15) {
            onExportMap(31);
        } else {
            toast.error("La justificación debe tener mínimo 15 caracteres");
        }
    };

    const changeState = (State: number) => {
        item.instance.changeAdquisitionItemApprovalNote(props.IDAdquisitionItem, _single.getAccountID(), response.Obs, State)
            .then((resp) => {
                return (resp)
            })
            .catch(err => console.log(err));
    }

    const handleButtonClick = (approveValue: "true" | "false") => {
        const newResponse = { ...response, Approve: approveValue };
        setResponse(newResponse);
        if (approveValue === "true") {
            handleApprove(newResponse);
        } else {
            handleDecline(newResponse);
        }
    };

    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-12 mb-2">
                    <label>Observaciones</label>
                    <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={() => handleButtonClick("true")}>Aprobar</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-close-circle-line" eventClick={() => handleButtonClick("false")}>Rechazar</BasicButton>
                </div>
            </div>

        </>
    );
}